import FriendlyPropertyCreate from './FriendlyPropertyCreate';

export default FriendlyPropertyCreate;
